import { ref } from '@vue/composition-api'

// odds range：odds 范围
const oddsRange = ref([])

export default function useOddsRange() {
  // 修改 odds 范围 赛事列表页 outcome使用
  const setOddsRange = (odds = []) => {
    oddsRange.value = odds
  }

  const resetOddsRange = () => {
    setOddsRange([])
  }

  return {
    oddsRange,
    setOddsRange,
    resetOddsRange
  }
}
